import { request } from "../_helpers/Auth";

const namespace = "/api/spaces";

export const getSpaces = () => {
    return request({
        url: namespace,
        method: "get",
    });
};

export const getSpace = (id) => {
    return request({
        url: `${namespace}/${id}`,
        method: "get",
    });
};

export const createSpace = (data) => {
    return request({
        url: namespace,
        method: "post",
        data,
    });
};

export const updateSpace = (id, data) => {
    return request({
        url: `${namespace}/${id}`,
        method: "put",
        data,
    });
};

export const deleteSpace = (id) => {
    return request({
        url: `${namespace}/${id}`,
        method: "delete",
    });
};
